export const environment = {
  production: true,
  baseURL: "../apipmx/", 
  navURL : "../apismx/",
  ms_host_ssl: "#{msHost}#",
  productName:"#{ProductName}#",
};